import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { areParametersSelected, getDataset } from 'store';

import SelectParametersModal from './SelectParametersModal';
import SelectedParametersList from './SelectedParametersList';
import { SelectTrigger, SettingsTrigger } from './SelectParametersModal/Triggers';

const DatasetParameters = ({ defaultTypesVariables }) => {
  const areParamsSelected = useSelector(state => areParametersSelected(state));
  const isDatasetUploaded = useSelector(state => !!getDataset(state));
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    if (!areParamsSelected && isDatasetUploaded) {
      openModal();
    }
  }, [isDatasetUploaded, areParamsSelected]);

  return (
    <div className="mb-30">
      <div className={areParamsSelected ? 'main-sidebar__params-collapsed' : ''}>
        <p className="font-700 mb-10">
          Variables
        </p>
        {areParamsSelected ? <SettingsTrigger onOpenModal={openModal} /> : ''}
      </div>

      <SelectParametersModal isOpen={isOpen} onCloseModal={closeModal} defaultTypesVariables={defaultTypesVariables} />

      {areParamsSelected
        ? <SelectedParametersList /> : <SelectTrigger onOpenModal={openModal} />
      }
    </div>
  );
};

DatasetParameters.propTypes = {
  defaultTypesVariables: PropTypes.object.isRequired
};

export default DatasetParameters;
